import router from "@/router";

/**
 * 跳转门户登录页（全屏，登录后可见主界面）
 * @param {string} [redirect] 登录成功后跳转路径
 */
export function openPortalLogin(redirect) {
  const q = redirect ? { redirect: redirect } : {};
  if (router.currentRoute && router.currentRoute.path === "/portal/login") {
    return;
  }
  router
    .push({ path: "/portal/login", query: q })
    .catch(function () {});
}

/** 关闭门户登录（兼容旧调用，登录页模式下无弹层） */
export function closePortalLogin() {
  /* no-op */
}
